import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Progress, Container} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

const cellular = [ 'קוד מוסד הוט מובייל 36716' , 'we קוד מוסד  28444' , 'קוד מוסד סלקום 25500','קוד מוסד גולן טלקום 54528'];
const tv = ['קוד מוסד יס 34000' , 'קוד מוסד בזק 703'];

class ModalClickOne extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            warning: '',
            errorText: '',
            provider: '',
            phone: ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchTasksDataIfNeeded(true));
    }


    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    render() {

        let Icon;

        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{maxWidth: '800px', width: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title' style={{textAlign: "center"}}>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            <Row>
                                <Col md={12} lg={12}>
                                    <form className="form">
                                        <div className="form__form-group">
                                            <div className="form__form-group">
                                                <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                    {cellular.map(e => {

                                                        return (
                                                        <Row style={{flexDirection: "row-reverse"}}>
                                                            <Col md={3} xs={12}>
                                                                <label className="form__form-group-label">
                                                                    {e}
                                                                </label>
                                                            </Col>
                                                        </Row> )
                                                    })}

                                                    <div className="progress-wrap progress-wrap--blue">
                                                        <Progress value={100} />
                                                    </div>

                                                    {tv.map(e => {

                                                        return (
                                                            <Row style={{flexDirection: "row-reverse"}}>
                                                                <Col md={3} xs={12}>
                                                                    <label className="form__form-group-label">
                                                                        {e}
                                                                    </label>
                                                                </Col>
                                                            </Row> )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.toggle}>לסגור</Button>{' '}
                    </ButtonToolbar>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ModalClickOne))